import React, { useEffect } from 'react';
import { useJoyride, STATUS, ACTIONS } from 'react-joyride';
import { TOUR_STEPS } from './tourSteps';
import { TOUR_STYLES, TOUR_LOCALE } from './tourStyles';
import { useTour } from '../../store/context/tour.context';

// react-joyride v3 removed the `callback` prop that the rest of this file's
// logic was written against — passing it silently does nothing, so closing a
// tour never actually ended it. useJoyride()'s `state` (status/action) is the
// v3 replacement; watch it here and call onEnd ourselves.
const ProductTourRunner = ({ onEnd }) => {
  const { Tour, state } = useJoyride({
    steps: TOUR_STEPS,
    run: true,
    continuous: true,
    showSkipButton: true,
    showProgress: true,
    disableBeacon: true,
    scrollToFirstStep: true,
    styles: TOUR_STYLES,
    locale: TOUR_LOCALE,
  });

  useEffect(() => {
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(state.status) || state.action === ACTIONS.CLOSE) {
      onEnd();
    }
  }, [state.status, state.action, onEnd]);

  return Tour;
};

const ProductTour = () => {
  const { tourActive, tourKey, endTour } = useTour();

  if (!tourActive) return null;

  return <ProductTourRunner key={tourKey} onEnd={endTour} />;
};

export default ProductTour;
